<template>
  <div class="header">
    <div class="header-cont">
      <div class="head-left">
        <div class="logoBox" @click="jumpGo">
          <img class="logo" src="../assets/home/logo.jpg"/>
        </div>
        <div class="infos">
          <div class="trem">{{ $i18n.locale === 'zh' ? trems : formatDate(trems)}}</div>
          <div class="icon">
            <!-- <span @click="switchLanguage()"><img src="../assets/img/language.svg" />
            {{$i18n.locale === 'zh' ? '简体中文' : 'English'}}</span> -->
            <a style="cursor: pointer;" @click="switchLanguage('zh')">中文</a>
            <!-- <i class="el-icon-search"></i> -->
            <span style="margin: 0 4px;"> | </span>
            <!-- <a v-if="$i18n.locale !== 'zh'" @click="switchLanguage('zh')">中文</a>
            <a v-else @click="switchLanguage('en')">EN</a> -->
            <a style="cursor: pointer;" @click="switchLanguage('en')">EN</a>
          </div>
        </div>
      </div>
      <div class="head-right">
        <div class="head-con" :class="yy=='zh'?'':'en-special'">
          <div
          class="navs new-class"
          v-for="(item, index) in leftPart"
          :key="index"
          @click="honeChange(item, index)"
          @mouseover="showToggle(item,index)"
          @mouseout="handleHide"
          :class="($i18n.locale === 'zh' ? item.name == isSelect : item.cnName == isSelect) ? 'bottom_btn' : 'bottom_b'"
        >
          <span :class="yy=='zh'?'font24':'font13'">{{ item.name }}</span>
          <template v-if ="item.children.length > 0">
            <div class="navItens" v-show="index == isShow" @click.stop>
              <a
                class="atc"
                v-for="(items, k) in item.children"
                :key="k"
                @click="ubdt(items, k)"
                :class="{ 'active': isChSelect == items.name }"
                >{{ items.name }}</a
              >
            </div>
          </template>
        </div>
      </div>
        </div>
  </div>
    <div class="header-min">
      <div class="btn" @click="open = true">
        <img src="@/assets/img/menu.svg" alt="">
      </div>
      <div class="menu-detail" :class="open ? (yy === 'zh' ? 'drawer' : 'drawer_en drawer') : (yy === 'zh' ? '' : 'drawer_en')">
        <i class="el-icon-close" @click="open = false"></i>
        <div class="infos">
          <div class="trem">{{ $i18n.locale === 'zh' ? trems : formatDate(trems)}}</div>
          <div class="icon">
            <!-- <span @click="switchLanguage()"><img src="../assets/img/language.svg" />
              {{$i18n.locale === 'zh' ? '简体中文' : 'English'}}
            </span> -->
            
            <a @click="switchLanguage('zh')">中文</a>
            <span>|</span>
            <a @click="switchLanguage('en')">EN</a>
          </div>
        </div>
        <div class="menu-list">
          <div v-for="(item, index) in leftPart"
            :key="index"
            @click="honeChange(item, index)"
            @mouseover="showToggle(item,index)"
            @mouseout="handleHide"
            >
            <div class="first">{{ item.name }}</div>
            <div v-if ="item.children.length > 0">
              <div
                v-for="(items, k) in item.children"
                :key="k"
                @click="ubdt(items, k)"
                :class="{ 'active': isChSelect == items.name }">
                <div class="second">{{ items.name }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      isShow: -1,
      isSelect:'首页',
      isChSelect:'',
      open: false,
      // yy: window.navigator.language == "zh-CN" ? 'zh' : 'en',
      yy: localStorage.getItem('yy') || 'zh',
      trems:''
    };
  },
  watch: {
    '$route':function(vals,olds){
      this.isSelect = vals.name;
      if(vals.name == '活动详情'){
        this.isSelect = '中心成果';
      }
      if(vals.name == '详情'){
        if(vals.query.tit1){
          this.isSelect = vals.query.tit1;
        }  
      }
    },
  },
  computed:{
    leftPart(){
      console.log(this.$t('nav'), '7777');
      
      return this.$t('nav')
    }
  },
  mounted() {
    this.isSelect = this.$route.name;
    console.log(this.$route.name, 'this.$route.name');
    
    this.getDate()
  },
  methods: {
    formatDate(inputDate) {
      const date = new Date(inputDate);
      if (isNaN(date)) {
        console.error('Invalid date format');
        return null;
      }
      const months = [
        'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun',
  'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'
      ];
      const day = date.getDate();
      const month = months[date.getMonth()];
      const year = date.getFullYear();
      return `${month} ${day}, ${year}`;
    },
    getDate(){
        // 补零
        let addZero = (t) => {
            return t < 10 ? '0' + t : t;
        }
        let time = new Date();
        let Y = time.getFullYear(), // 年
            M = time.getMonth() + 1, // 月
            D = time.getDate(), // 日
            h = time.getHours(), // 时
            m = time.getMinutes(), // 分
            s = time.getSeconds(); // 秒
        if (M > 12) {
            // 注: new Date()的年月日的拼接，在月份为12月时，会出现 获取月份+1 后，为13月的bug，需要特殊处理。用moment第三方插件获取时间也可避免此问题。
            M = M - 12;
        }
        //${addZero(h)}:${addZero(m)}:${addZero(s)}
        if(this.$i18n.locale == 'zh'){
          this.trems = `${Y}年${addZero(M)}月${addZero(D)}日`;
        }else{
          this.trems = `${Y}-${addZero(M)}-${addZero(D)}`;
        }
        
    },
    switchLanguage(val) {
      let lang = ''
      if (this.$i18n.locale === 'zh') {
        lang = 'en'
      } else {
        lang = 'zh'
      }
      // this.yy = lang;
      this.yy = val;
      // sessionStorage.setItem('yy',this.yy)
      localStorage.setItem('yy',this.yy)
      // this.$i18n.locale = lang; // 设置当前语言
      this.$i18n.locale = val; // 设置当前语言
      this.open = false;
      this.getDate()
      if (this.$route.path === '/Interformation') {
        location.reload()
      }
    },
    ubdt(row, i) {
      this.open = false
      if(row.name == '国际标准') {
        window.open('https://www.itu.int/rec/T-REC/en');
      } else {
        if (row.path) {
          this.isSelect = row.nameP;
          this.isChSelect = row.name;
          if(row.isPont){
            let parseUrl = {
              isPont:row.isPont,
              isSelect:this.isSelect
            }
            this.$bus.$emit('changePont',parseUrl)
          }
          this.$router.push({ path: row.path });
        }
      }
    },
    showToggle(item,index) {
        this.isShow = index;
    },
    handleHide() {
        this.isShow = false;
    },
    honeChange(item, index) {
      console.log(item.name, 'item.name');
      
      this.open = false
      this.isSelect = item.name;
      console.log(item.path, 'item.path')
      
      this.$router.push({ path: item.path });
    },
    jumpGo() {
      this.$router.push({ path: '/home' });
    }
  },
};
</script>
<style lang="scss" scoped>
.font24{
  font-size: 20px;
}
.font13{
  font-size: 16px;
}
.header {
  width: 100%;
  height: 180px;
  min-height: 180px;
  background: rgba(255, 255, 255, 0.9);
  // position: fixed;
  z-index: 999;
  // border-bottom: 1px solid #ccc;
  margin-bottom: 20px;
  .header-min {
    display: none;
  }
  .header-cont{
    
  }
  .head-left {
    height: 100px;
    max-width: 1200px;
    margin: 0 auto;
    display: flex;
    justify-content: space-between;
    align-items: center;
    background: #fff;
    // padding: 0 100px;
    .logoBox{
      display: flex;
      align-items: center;
      max-width: 50%;
      cursor: pointer;
    }
    .logo{
      width: 100%;
    }
    .infos{
      flex: 1;
      .trem{
        font-size: 18px;
        text-align: right;
        cursor: default;
      }

      .icon{
        margin-top: 15px;
        display: flex;
        align-items: center;
        justify-content:flex-end;
        font-size: 18px;
        img{
          width: 20px;
          margin: 2px 6px 0 0;
        }
        span{
          // margin: 0 15px;
          display: flex;
          align-items: center;
          cursor: pointer;
        }
        a:hover{
          color: #1b3e92;
        }
      }
    }
  }
  .head-right {
    .head-con {
      margin: 0 auto;
      max-width: 1200px;
      display: flex;
      align-items: center;
      // justify-content: center;
      justify-content: space-around;
      position: relative;
      z-index: 11;
      background: #f5f5f5;
    }
    .en-special {
      .navs {
        margin-right: 2px !important;
      }
    }
    // display: flex;
    // align-items: center;
    // justify-content: center;
    // position: relative;
    // z-index: 11;
    // background: #ffffff20;
    .navs {
      color: #000000;
      font-weight: 600;
      padding: 0 10px;
      height: 80px;
      line-height: 80px;
      margin-right: 30px;
      // color: #fff;
      text-align: center;
      cursor: pointer;
      // display: -webkit-box;
      // -webkit-line-clamp: 1; //显示最大行数
      // -webkit-box-orient: vertical;
      // overflow: hidden;
      // text-overflow: ellipsis;
      z-index: 1001;
      position: relative;
      font-family: Inter;
      .navItens {
        font-weight: 400;
      }
    }
    .navs:hover {
      height: 74px;
      line-height: 74px;
      padding-top: -1px;
      border-bottom: #1b3e92 3px solid;
    }
    .bottom_btn{
      color: #1b3e92;
      padding-top: -1px;
      height: 74px;
      line-height: 74px;
      border-bottom: #1b3e92 3px solid;
    }
    .navItens {
      position: absolute;
      margin-top: -1px;
      left: 0;
      background: rgba(255, 255, 255, 0.9);
      box-shadow: 0px 4px 15px 0px rgba(0,0,0,0.2);
      color: #080808;
      font-size: 18px;
      padding: 10px 0px;
      a {
        display: block;
        height: 36px;
        line-height: 36px;
        color: #080808;
        // margin-left: 12px;
        white-space: nowrap;
        text-align: left;
        padding: 0 20px;
      }
      .atc:hover {
        color: #1B3E92;
        font-size: 18px;
      }
      .active{
        color: #1B3E92;
        font-size: 18px;
      }
    }
  }
}
@media (min-width: 600px) and (max-width: 1040px) {
  .head-right {
    .navs {
      margin-right: 1% !important;
      padding: 0 2px !important;
      &>span {
        font-size: 18px !important;
      }
    }
  }
}
@media (min-width: 600px) and (max-width: 1200px) {
  .navs {
    line-height: 30px !important;
    display: flex;
    align-items: center;
    .navItens {
      top: 78px !important;
    }
  //   display: -webkit-box;
  //   -webkit-line-clamp: 1; //显示最大行数
  //   -webkit-box-orient: vertical;
  //   overflow: hidden;
  //   text-overflow: ellipsis;
  //   margin-right: 0px !important;
  //   .font13 {
  //     font-size: 12px !important;
  //   }
  }
}
@media (max-width: 600px) {
  .header {
    position: absolute !important;
    background: none !important;
    height: auto !important;
    min-height: auto !important;
    .header-cont {
      display: none !important;
    }
    .header-min {
      display: block;
      .btn {
        position: absolute;
        left: 0;
        top: 0;
        width: 50px;
        height: 40px;
        text-align: left;
        img {
          margin: 5px;
          width: 30px;
          height: 30px;
        }
      }
      .menu-detail {
        position: absolute;
        top: -1000px; /* 初始时抽屉隐藏在顶部 */
        left: 0;
        // height: 560px;
        width: 170px;
        letter-spacing: 1px;
        box-shadow: 8px 8px 8px rgba(0, 0, 0, 0.1);
        background: #fff;
        transition: top 0.5s ease;
        z-index: 1000;
        .infos {
          margin-top: 10px;
          text-align: left;
          padding: 0 0 10px 5px;
          border-bottom: 1px solid #ccc;
        }
      }
      .infos {
        font-size: 14px;
        color: #1D3E95;
      }
      .icon {
        margin-top: 4px;
        display: flex;
        // align-items: center;
        img{
          width: 16px;
          margin: 0px 6px 0 0;
        }
        span {
          // margin: 0 6px;
          display: flex;
        }
      }
      .drawer_en {
        // height: 470px;
        width: 250px !important;
        letter-spacing: 0px;
      }
      .drawer {
        top: 0 !important; /* 抽屉下拉 */
      }
      .el-icon-close {
        position: absolute;
        top: 5px;
        right: 5px;
      }
      .menu-list {
        box-sizing: border-box;
        padding: 10px;
        text-align: left;
        .first {
          font-size: 14px;
          margin: 8px 0 8px 0px;
        }
        .second {
          margin: 8px 0 8px 16px;
          font-size: 12px;
        }
      }
    }
  }
}
</style>
